import AccountingApp from "./accounting_app";
import { AuthProvider, useAuth } from "./AuthContext";
import LoginPage from "./LoginPage";

const AppContent = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <AccountingApp /> : <LoginPage />;
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
